const TZ = 'Asia/Kolkata';

export const istDateTime = (d, opts) =>
  d ? new Date(d).toLocaleString('en-IN', { timeZone: TZ, ...(opts || {}) }) : '—';

export const istDate = (d, opts) =>
  d ? new Date(d).toLocaleDateString('en-IN', { timeZone: TZ, ...(opts || {}) }) : '—';

export const istTime = (d, opts) =>
  d ? new Date(d).toLocaleTimeString('en-IN', { timeZone: TZ, ...(opts || {}) }) : '—';

// YYYY-MM-DD of "today" in IST, regardless of browser timezone
export const istTodayStr = (offsetDays = 0) => {
  const d = new Date(Date.now() + 330 * 60000 + offsetDays * 86400000);
  return d.toISOString().slice(0, 10);
};
